import React from "react";
import styled from "styled-components";
import { breakpoints } from "../../styles/variables";

const ItemElem = styled.div`
  text-align: left;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  margin-bottom: 10px;
  padding: 30px 36px 40px 36px;

  .title {
    display: grid;
    grid-template-columns: 30px 1fr;
    grid-gap: 12px;
    margin-bottom: 10px;

    .icon {
      background: ${(props) =>
        `url('/assets/gestaltungselemente/${props.icon}')`};
      background-repeat: no-repeat;
      margin-top: 0;
      background-size: contain;
      width: 30px;
      height: 27.5px;
    }
  }

  h3 {
    font: 20px / 26px "FS Regular";
    /* margin-top: -8px; */

    span,
    b,
    strong {
      font-family: "Mrs Eaves Bold Italic";
    }
  }

  p {
    font: 18px / 22px "Mrs Eaves Regular";
  }

  @media screen AND (min-width: ${breakpoints.tablet}px) {
    justify-content: center;
    padding: 30px 36px 20px 36px;
  }

  @media screen AND (min-width: ${breakpoints.desktop}px) {
    padding: 60px 110px 30px;
    margin-bottom: 0;
    justify-content: center;

    .title {
      grid-template-columns: 38px 1fr;
      grid-gap: 22px;
      margin-bottom: 22px;

      > .icon {
        width: 38.24px;
        height: 35px;
        margin-top: -4px;
      }
    }

    > div {
      width: 100%;
      max-width: 533px;
      margin: 0 auto;
    }

    p {
      font: 24px / 30px "Mrs Eaves Regular";
    }

    h3 {
      font: 28px / 36px "FS Regular";
      margin-top: 0;
    }
  }
`;

interface IconItemProps {
  icon: string;
  title: string;
  text: string;
}

const IconItem: React.FC<IconItemProps> = ({ icon, title, text }) => (
  <ItemElem icon={icon}>
    <div className="title">
      <div className="icon" />
      <h3>{title}</h3>
    </div>
    <div dangerouslySetInnerHTML={{ __html: text }}></div>
  </ItemElem>
);

export default IconItem;
